var _rect, _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5DRound1M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 30,
    fill: "url(#paint0_linear_55_16157)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint1_linear_55_16157)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_16157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint2_linear_55_16157)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_16157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 52L18.5 48L15.5 31L36 23L40 24L66.5 12.5L111.5 48L108 52L105 54L98 61.5L65 98L20.5 61.5L24 52Z",
    fill: "#D36806"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7276 21.4586L36.2111 23.1317L38.0404 29.9586L22.1181 34.225L23.5385 39.526L23.6901 39.6592L29.478 38.1084C33.4447 37.0455 36.547 37.0839 38.7849 38.2235C41.0228 39.3631 42.6152 41.7 43.5621 45.234C44.567 48.9843 44.1294 52.039 42.2492 54.398C40.369 56.757 36.9588 58.5984 32.0184 59.9222C29.6744 60.5503 27.5178 61.0122 25.5486 61.3079C23.9174 61.522 22.3823 61.5557 20.9909 61.5863C20.604 61.4777 20.604 61.4777 20.604 61.4777L18.6375 59.9341L19.3446 58.7093L18.3952 55.1661L18.4744 55.0289C19.3257 55.0327 20.3116 54.9618 21.4321 54.8161C22.5886 54.6608 23.7584 54.4827 24.9413 54.2817C26.1146 54.0446 27.1701 53.8004 28.1077 53.5492C30.3435 52.9501 32.0274 52.383 33.1594 51.8477C34.2915 51.3125 35.0014 50.7164 35.2892 50.0596C35.6034 49.357 35.6252 48.5008 35.3546 47.4911C35.0165 46.229 34.4684 45.4096 33.7104 45.0329C32.9788 44.6105 31.7295 44.6361 29.9625 45.1096L18.5589 48.0495L16.5923 46.5058L17.2682 45.2895L12.7837 29.2473L33.3137 23.888L34.7276 21.4586Z",
    fill: "#FFDAB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.323 52.7472L51.276 54.2406L65.9204 50.3166C68.9135 49.5146 71.3569 48.6087 73.2507 47.5988C75.1349 46.5528 76.5209 45.2345 77.4088 43.6439C78.2967 42.0532 78.7067 40.0495 78.6389 37.6327C78.5711 35.2159 78.0589 32.2224 77.1023 28.6524C76.1844 25.2266 75.165 22.5043 74.0444 20.4856C72.914 18.4308 68.7938 13.3659 65.8613 12.0811C65.9908 12.564 66.6125 14.7468 64.4675 14.8192C62.3128 14.8554 59.7389 15.2745 56.7458 16.0765L41.7623 20.0913L49.9567 51.1946L49.323 52.7472ZM57.4583 23.7123L52.3737 25.0747L57.635 44.71L62.7196 43.3476C64.8112 42.7872 66.3891 42.1131 67.4536 41.3255C68.554 40.5282 69.1634 39.3406 69.2818 37.7629C69.4362 36.1755 69.1221 33.9213 68.3394 31.0004C67.5954 28.2237 66.7742 26.2406 65.8757 25.0513C65.0037 23.8163 63.8967 23.1466 62.5546 23.0424C61.2487 22.9286 59.5499 23.1518 57.4583 23.7123Z",
    fill: "#FFDAB8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3231 52.7472L46.6147 50.367L48.4732 49.5216L40.2789 18.4183L55.2623 14.4035C58.2554 13.6015 60.8293 13.1824 62.984 13.1461C65.129 13.0738 65.3785 12.2105 65.249 11.7275C68.1815 13.0123 71.4305 16.7577 72.5609 18.8125C73.6816 20.8312 74.7009 23.5535 75.6188 26.9793C76.5754 30.5494 77.0876 33.5428 77.1554 35.9596C77.2233 38.3764 76.8132 40.3801 75.9253 41.9708C75.0374 43.5615 73.6514 44.8798 71.7673 45.9258C69.8734 46.9357 67.43 47.8416 64.4369 48.6436L49.3231 52.7472ZM50.8902 23.4017L55.9749 22.0392C58.0664 21.4788 59.7652 21.2555 61.0711 21.3694C62.4132 21.4736 63.5202 22.1432 64.3922 23.3783C65.2907 24.5676 66.1119 26.5506 66.8559 29.3273C67.6386 32.2483 67.9527 34.5025 67.7983 36.0899C67.6799 37.6676 67.0705 38.8551 65.9701 39.6524C64.9057 40.4401 63.3277 41.1141 61.2361 41.6746L56.1515 43.037L50.8902 23.4017Z",
    fill: "#D16A0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7276 21.4586L31.8899 18.5955L31.8302 22.215L11.3002 27.5742L15.7847 43.6164L13.8841 44.1257L16.5924 46.5058L28.479 43.4365C30.246 42.963 31.4953 42.9375 32.2269 43.3599C32.9848 43.7365 33.5329 44.5559 33.8711 45.8181C34.1417 46.8278 34.1199 47.6839 33.8057 48.3865C33.5179 49.0434 32.8079 49.6395 31.6759 50.1747C30.5439 50.7099 28.8599 51.2771 26.6241 51.8762C25.6865 52.1274 24.6311 52.3715 23.4578 52.6086C22.2749 52.8096 21.1051 52.9878 19.9486 53.1431C18.8281 53.2887 17.8422 53.3596 16.9909 53.3559L16.9117 53.493L17.8611 57.0363L15.9292 57.5539L18.6375 59.9341C18.9206 59.9261 19.2107 59.9197 19.5073 59.9132C20.8987 59.8827 22.4338 59.8489 24.065 59.6349C26.0343 59.3391 28.1909 58.8772 30.5348 58.2491C35.4752 56.9254 38.8855 55.084 40.7657 52.725C42.6459 50.366 43.0835 47.3113 42.0786 43.5609C41.1317 40.0269 39.5393 37.6901 37.3014 36.5505C35.0635 35.4109 31.9612 35.3725 27.9945 36.4354L22.2066 37.9862L22.055 37.8529L20.6346 32.5519L36.5569 28.2855L34.7276 21.4586Z",
    fill: "#D16A0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6148 50.3671L37.4268 16.0767L52.5536 12.0235C55.5467 11.2215 58.1206 10.8024 60.2753 10.7661C62.4203 10.6938 64.2701 11.1064 65.8247 12.004C67.3793 12.9015 68.7218 14.3777 69.8522 16.4325C70.9728 18.4512 71.9921 21.1735 72.9101 24.5993C73.8667 28.1694 74.3789 31.1628 74.4467 33.5796C74.5145 35.9964 74.1045 38.0001 73.2166 39.5908C72.3287 41.1815 70.9427 42.4998 69.0585 43.5458C67.1647 44.5557 64.7213 45.4616 61.7282 46.2636L46.6148 50.3671ZM53.2661 19.6592L48.1815 21.0217L53.4428 40.657L58.5274 39.2946C60.619 38.7341 62.1969 38.0601 63.2613 37.2724C64.3618 36.4751 64.9712 35.2876 65.0896 33.7099C65.244 32.1225 64.9299 29.8683 64.1472 26.9473C63.4032 24.1706 62.582 22.1876 61.6835 20.9983C60.8115 19.7632 59.7045 19.0936 58.3624 18.9894C57.0564 18.8755 55.3577 19.0988 53.2661 19.6592Z",
    fill: "url(#paint3_linear_55_16157)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8841 44.1254L8.70768 24.8069L31.8899 18.5952L33.9375 25.8816L17.9263 30.1718L19.3467 35.4728L19.4984 35.6061L25.2862 34.0552C29.253 32.9924 32.3553 33.0307 34.5931 34.1704C36.831 35.31 38.4234 37.6468 39.3704 41.1808C40.3753 44.9312 39.9376 47.9859 38.0575 50.3449C36.1773 52.7039 32.767 54.5453 27.8266 55.869C25.4826 56.4971 23.326 56.959 21.3568 57.2548C19.3779 57.5145 17.5404 57.5084 15.9292 57.5536L14.2034 51.1129L14.2826 50.9757C15.134 50.9795 16.1199 50.9086 17.2403 50.763C18.3969 50.6077 19.5666 50.4295 20.7496 50.2285C21.9229 49.9914 22.9783 49.7473 23.9159 49.496C26.1517 48.897 27.8356 48.3298 28.9677 47.7946C30.0997 47.2593 30.8096 46.6633 31.0974 46.0064C31.4116 45.3038 31.4334 44.4477 31.1629 43.438C30.8247 42.1758 30.2766 41.3564 29.5186 40.9798C28.7871 40.5574 27.5378 40.5829 25.7708 41.0564L13.8841 44.1254Z",
    fill: "url(#paint4_linear_55_16157)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3691 71.3647L53.0014 61L49.6337 71.3647L42.1362 71.4601L39 69.5V71.5L47.5523 77.7705L45.3506 85.1494L44.5 86V88L53.0014 81.7295L61.5 88V86L60.6505 85.1505L58.4504 77.7705L67.5 71.5V69.5L62.5 71L63.4004 71.4502L56.3691 71.3647Z",
    fill: "#DA7108"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6936 58.8652L56.0613 69.23L67.5 69.5L58.1426 75.6357L61.5 86L52.6936 79.5947L44.5 86L47.2445 75.6357L39 69.5L49.3258 69.23L52.6936 58.8652Z",
    fill: "#F4D32D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8304 53.6718L75.1394 47.387L73.6223 54.0533L68.9436 54.5374L66.8732 53.4904L66.9865 54.74L72.6847 58.1732L71.7271 62.908L71.2438 63.4876L71.3571 64.7371L76.3133 60.3381L81.9781 63.7744L81.8648 62.5248L81.286 62.0422L79.4935 57.556L84.7922 53.126L84.679 51.8764L81.6401 53.0967L82.2281 53.327L77.8304 53.6718Z",
    fill: "#DA7108"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8267 46.0705L77.5177 52.3553L84.6795 51.8762L79.1808 56.2396L81.8653 62.5246L76.0007 59.0216L71.2444 63.4874L72.3721 56.8567L66.8737 53.4902L73.3097 52.7368L74.8267 46.0705Z",
    fill: "#F4D32D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1634 69.5675L25.6092 73.1656L30.0242 71.9947L27.1207 75.3894L29.5624 78.9884L25.4729 77.5141L23.0456 80.8824L22.943 76.6035L19.0989 75.1699L23.0272 73.916L23.1634 69.5675Z",
    fill: "#F4DE6C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55H7L12 61L9 55Z",
    fill: "#F4DE6C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7663 9.70488L32.007 10.5566C31.6383 10.6401 31.4864 11.0825 31.726 11.3749C31.8417 11.5161 32.0241 11.5845 32.2041 11.5541L36.0049 10.9122C36.5099 10.8269 36.696 10.198 36.3185 9.85168C36.1697 9.71511 35.9633 9.66025 35.7663 9.70488Z",
    fill: "#72FBBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_16157",
    x1: 88,
    y1: 0.0000104904,
    x2: 0.0000104904,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_16157",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_16157",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_16157",
    x1: 38.7244,
    y1: 17.75,
    x2: 45.9713,
    y2: 44.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCFA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55_16157",
    x1: 38.7242,
    y1: 17.7497,
    x2: 45.9712,
    y2: 44.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCFA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5DRound1M);
export default __webpack_public_path__ + "static/media/5d_round_1m.c694302add0535c4c2202f2d3197f9b4.svg";
export { ForwardRef as ReactComponent };